import React from "react";
import Link from "gatsby-link";
import { Dropdown } from "semantic-ui-react";
import { SocialMediaButtonsGrid } from "@fishrmn/fishrmn-components";

import { baseConfig, socialMediaConfig } from "../../../config/config";
import { linksOrder } from "../../../config/baseConfig";

import CancelButton from "./CancelButton";
import NavigationLogo from "./NavigationLogo";
import NavigationLink from "./NavigationLink";
import OrderButton from "./OrderButton";

const { pageMetadata } = baseConfig;
const pageKeys = Object.keys(pageMetadata);

function getGroup(groupName) {
  const keys = Object.keys(pageMetadata).filter(
    key => pageMetadata[key].groupName === groupName
  );

  return keys.map(key => pageMetadata[key]);
}

const DropdownGroup = ({ group }) => {
  const { name, links } = group;

  return (
    <Dropdown text={name} className="navigation-dropdown">
      <Dropdown.Menu>
        {links.map(({ displayTitle, path }) => (
          <Dropdown.Item text={displayTitle} as={Link} to={path} />
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

const NavigationOverlay = ({ onToggle, currentLocation }) => (
  <div id="nav-overlay-container">
    <div id="overlay-header">
      <CancelButton onToggle={onToggle} />
      <NavigationLogo onToggle={onToggle} />
    </div>
    <div id="overlay-links">
      {/*{linksOrder.map(({ slug, groupName }) => {*/}
      {/*if (groupName) {*/}
      {/*const group = {*/}
      {/*name: groupName,*/}
      {/*links: getGroup(groupName)*/}
      {/*};*/}

      {/*return <DropdownGroup group={group} />;*/}
      {/*}*/}

      {/*const page = pageMetadata[slug];*/}
      {/*return (*/}
      {/*<div className="nav-link" key={slug}>*/}
      {/*<NavigationLink*/}
      {/*pageMetadata={page}*/}
      {/*isActive={currentLocation === page.path}*/}
      {/*isInternal={*/}
      {/*slug !== "joinus" &&*/}
      {/*slug !== "ourmenu" &&*/}
      {/*slug !== "jobs" &&*/}
      {/*slug !== "giftCards"*/}
      {/*}*/}
      {/*/>*/}
      {/*</div>*/}
      {/*);*/}
      {/*})}*/}
      {pageKeys.map(
        pageKey =>
          !(pageKey === "orderOnline") &&
          pageMetadata[pageKey].toDisplay !== false && (
            <div key={pageKey} onClick={onToggle}>
              <NavigationLink
                pageMetadata={pageMetadata[pageKey]}
                isActive={currentLocation === pageMetadata[pageKey].path}
                isInternal={
                  pageKey !== "joinus" &&
                  pageKey !== "ourmenu" &&
                  pageKey !== "allergyMenu" &&
                  pageKey !== "jobs" &&
                  pageKey !== "giftCards"
                }
              />
            </div>
          )
      )}
      <OrderButton
        linkType="a"
        link="mailto:hi@wholesol.com"
        text="CONTACT US"
      />
      <OrderButton
        linkType="a"
        link="https://www.wholesolblendbar.com/s/order"
        text="ORDER PICKUP"
      />
      <OrderButton
        link="/locations/"
        text="ORDER DELIVERY"
        onClick={onToggle}
      />
    </div>
    <div id="overlay-footer">
      <SocialMediaButtonsGrid socialMediaConfig={socialMediaConfig} />
    </div>
  </div>
);

export default NavigationOverlay;



// WEBPACK FOOTER //
// ./src/components/Navigation/NavigationOverlay.jsx